Namespace 'Monitoring.Reports.DailyInsights'

class Monitoring.Reports.DailyInsights.MetricsView extends Backbone.View
  className: 'metrics'
  template: JST['backbone/templates/monitoring/reports/daily_insights/metrics']

  initialize: (@options = {}) ->
    # just set @options

  render: ->
    @$el.addClass("rendering")
    params = {id: @options.post.id, channel_id: @options.post.channel_id, original_network: @options.section}
    if @options.post.updated_data
      url = "/monitoring/reports/daily_insights/facebook_metrics"
    else
      url = "/monitoring/reports/daily_insights/" + @options.section + "_metrics"
  
    $.post url, params, (response) =>
      @promoted = @isPromoted(response)
      # next line: see https://developers.facebook.com/bugs/587264174801492
      impressions = response.unformatted_impressions
      interactions = response.unformatted_interactions
      @hidePost() if (impressions <= 10) || (impressions < interactions)
      @$el.html(@template(_.extend({}, response, {parse: @parse, parsePrice: @parsePrice, parseAvg: @parseAvg, last_period: @options[_this.options.section][0].last_period, isPromoted: @promoted})))
      @$el.removeClass("rendering")
    return this

  parse: (input) ->
    input = input.toString()
    if parseFloat(input.replace('.', '').replace(',', '.'),10) == parseInt(input, 10)
      parseInt(input)
    else
      parseFloat input.replace('.', '').replace(',', '.')

  hidePost: ->
    console.log('Post eliminado (no valido)')
    @$el.parents('.post').css('display', 'none')

  parsePrice: (price) =>
    if not @promoted
      "-"
    else
      "$" + price

  parseAvg: (value) =>
    if not @promoted 
      "- avg."
    else
      "$" + value + " avg."

  isPromoted: (response) =>
    response.advertising_fee
